
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-strapi",
      function () {
        return require("private-next-pages/why-strapi.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-strapi"])
      });
    }
  